
import React, { memo,useEffect,useState } from 'react';
import { Layout, Menu, Breadcrumb,Row, Col, Button, Table, Tag, Drawer, Form, Select, Input, Space, message, Modal, Switch } from 'antd';
import { EditOutlined, SendOutlined, DeleteOutlined,PlusOutlined,ExclamationCircleOutlined } from '@ant-design/icons';
import './style.scss'
import { useNavigate } from "react-router-dom";
import Colors from '../../assets/themes/colors';
import GlobalSider from '../../components/GlobalSider';
import { addDataWithToken, addDataWithTokenContent, appIdentifier, deleteDataWithToken, editDataWithToken, editDataWithTokenContent, getDataWithToken, getLocal } from '../../globalFunctions/api';
import GlobalHeader from '../../components/GlobalHeader';
const {Content} = Layout;
const { Column, ColumnGroup } = Table;
const { Option } = Select;
const {confirm} = Modal

const pageTitle = 'ادارة المدراء';

const  MngAdmins = ()=> {
    const navigate = useNavigate();
    const [addAdminForm] = Form.useForm()
    const [editAdminForm] = Form.useForm()

    const [addAdminVisible, setAddAdminVisible] = useState(false);
    const [editAdminVisible, setEditAdminVisible] = useState(false);
    
    const [addLoading, setAddLoading] = useState(false);
    const [selectedAdmin, setSelectedAdmin] = useState(null)
    const [AdminFormInfo, setAdminFormInfo] = useState(null)
    const [Admins, setAdmins] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const [adminInfo, setadminInfo] = useState([]);
    const [departs, setDeparts] = useState([]);

    const getAdminInfo = ()=>{
        getDataWithToken('users/me?populate=*',(err,result)=>{
            setadminInfo(result)
        })
    }
    

    const handleTableChange = (pagination, filters, sorter) => {
        const{current,pageSize} = pagination 
        getAdmins(current,pageSize)
      };


      const onAddClose = () => {
        setAddAdminVisible(false);
        setSelectedAdmin(null)
        addAdminForm.resetFields()
        
      };

      const onEditClose = () => {
        setEditAdminVisible(false);
        setSelectedAdmin(null)
        editAdminForm.resetFields()
        
      };

   
   

      const getAdmins = (current=1,pageSize=25)=>{
        const userType = getLocal(appIdentifier)?.user?.user_type
        console.log({userType})
        setAddLoading(true)
        getDataWithToken(`admins/get_admins?pagination[pageSize]=${pageSize}&pagination[page]=${current}&populate=*`,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            console.log('res+++', result)
            setAdmins(result);
            setTotalCount(result?.meta?.total)
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      const addAdmin = (dataFromForm)=>{
        const {username,password,fname,user_type,depart,college, university} = dataFromForm || ''

        let collegeId = adminInfo?.user_type == 'college' ? adminInfo?.college?.id : college
        let universityId = adminInfo?.user_type == 'college' ? adminInfo?.university?.id : university
        const data ={username,password,role:1,fname,email:`${username}@uom_meetings.com`,confirmed:true,user_type,depart,college:collegeId,university:universityId}
        console.log(data)

       
        setAddLoading(true)
        addDataWithTokenContent(`users`,data,
        (err,result)=>{
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            message?.success('تم اضافة المدير بنجاح');
            getAdmins();
            addAdminForm?.resetFields();
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }

      function showDeleteConfirm(A_field_name,id) {
        confirm({
            title: `  هل انت متأكد انك تريد حذف  ( ${A_field_name} )  `,
            icon: <ExclamationCircleOutlined style={{color:'red'}} />,
            content: 'ملاحظة : البيانات المحذوفة لا يمكن استعادتها لاحقا',
            okText: 'نعم',
            okType: 'danger',
            cancelText: 'الغاء',
            width:480,
            style:{textAlign:'right'},
            onOk() {
                setAddLoading(true);
                
                deleteDataWithToken(`users/${id}`,(err, result)=>{

                    const {error} = result
                    if(err){
                        message?.error('خطأ في الشبكة')
                    }else{
                        if(!error){
                            message?.success('تم حذف المدير بنجاح');
                            getAdmins();
                        }else{
                            console.log(error)
                            message?.error(error?.message)
                        }
                    
                    }
                })

            },
            onCancel() {
                console.log('Cancel');
            },
            });
        }   

        const prepareEdit = (data)=>{
            console.log(data)
            setSelectedAdmin(data)
            const newData = data
            editAdminForm.setFieldsValue(newData)
            editAdminForm.setFieldsValue({depart:data?.depart?.id})
            setEditAdminVisible(true)
        }

        const editAdmin = (data)=>{
         
            setAddLoading(true);
            editDataWithTokenContent(`users/${selectedAdmin?.id}`,data,(err, result)=>{
                const {error} = result
                if(err){
                    message?.error('خطأ في الشبكة')
                }else{
                    if(!error){
                        message?.success('تم تعديل المدير بنجاح');
                        getAdmins();
                    }else{
                        console.log(error)
                        message?.error(error?.message)
                    }
                
                }
            })
          }


      useEffect(() => {
        getAdminInfo();
        
      }, [])

      useEffect(() => {
        console.log('adminInfo heeere', adminInfo)
        if(adminInfo){
            getMainStructureContent();
            getAdmins();
        }
      
      }, [adminInfo])



    const returnUserTypeTitle = (userType)=>{
        switch(userType){
            case 'main':
                return 'مدير النظام'
            case 'college':
                return 'مدير كلية'
            case 'university':
                return 'مدير جامعة'
            case 'depart':
                return 'مدير قسم'
            default:
                return 'غير معروف'
        }
    }

    const returnAccountTypesByAdminType = ()=>{
        const userType = getLocal(appIdentifier)?.user?.user_type

        
        let accountTypesArr = [
            {title:'مدير رئيسي للنظام', value:'main'},
            {title:'مدير جامعة', value:'university'},
            {title:'مدير كلية', value:'college'},
            {title:'مدير قسم', value:'depart'},
        ]

        if(userType == 'main'){
            return accountTypesArr
        }else
        if(userType == 'university'){
            let resArr = accountTypesArr.slice(2,4);
            return resArr
        }else
        if(userType == 'college'){
            let resArr = accountTypesArr.slice(3,4);
            return resArr
        }else
        if(userType == 'depart'){
            let resArr = accountTypesArr.slice(3,4);
            return resArr
        }



    }


    const getMainStructureContent = ()=>{
        if( adminInfo?.user_type == 'college'){
            getDeparts();
        }
       
    }

    const getDeparts = (current=1,pageSize=1000)=>{
        setAddLoading(true)
        getDataWithToken(`departs?pagination[pageSize]=${pageSize}&pagination[page]=${current}`,
        (err,result)=>{
            console.log('depart res+++', result)
          setAddLoading(false);
          const {error} = result
          if(err){
            message?.error('خطأ في الشبكة')
          }else{
           if(!error){
            setDeparts(result?.data);
           }else{
            console.log(error)
             message?.error(error?.message)
           }
           
          }
        }) 
      }
      
    
    
    return(
        <Layout className='mainContainer'>

            <Drawer
                    title="اضافة مدير"
                    placement="left"
                    closable={false}
                    onClose={onAddClose}
                    visible={addAdminVisible}
                    width={350}
                >
                <Form 
                    form={addAdminForm} 
                    onFinish={addAdmin}
                    onValuesChange={(changedValues,allValues)=>{
                        setAdminFormInfo(allValues);
                    }}
                    layout='vertical'
                >


                    <Form.Item    
                    style={{minWidth:250, marginBottom:20}}  
                    className='myFormItem'
                    name="user_type" 
                    rules={[{ required: true, message: 'يرجى اختيار نوع الحساب" ' }]}
                    label="نوع الحساب"
                    >
                        <Select size="large"  placeholder="نوع الحساب" style={{minWidth:290}}>
                            {
                                returnAccountTypesByAdminType()?.map(({value,title},index) => {
                                    return(<Option value={value} key={value} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    
                    

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="fname" 
                        label=" الاسم الثلاثي"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاسم الثلاثي',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاسم الثلاثي"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="username" 
                        label="اسم المستخدم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم المستخدم',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم المستخدم"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="password" 
                        label="كلمة المرور"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة كلمة المرور',
                            }
                          ]}
                        >
                             <Input.Password size="large" placeholder="كلمة المرور"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    <Form.Item    
                    style={{minWidth:250, marginBottom:20}}  
                    className='myFormItem'
                    name="depart" 
                    rules={[{ required: true, message: 'يرجى اختيار القسم " ' }]}
                    label=" القسم"
                    >
                        <Select size="large"  placeholder="القسم" style={{minWidth:290}}>
                            {
                                departs?.map(({id,title},index) => {
                                    return(<Option value={id} key={id} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    {/* <Form.Item label="مفعل" name="active" valuePropName="checked" >
                        <Switch  />
                    </Form.Item> */}
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{addAdminForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>


            <Drawer
                    title={`تعديل ${selectedAdmin?.fname}`}
                    placement="left"
                    closable={false}
                    onClose={onEditClose}
                    visible={editAdminVisible}
                    width={350}
                >
                <Form 
                    form={editAdminForm} 
                    onFinish={editAdmin}
                    onValuesChange={(changedValues,allValues)=>{
                        setAdminFormInfo(allValues);
                    }}
                    layout='vertical'
                >

<Form.Item    
                    style={{minWidth:250, marginBottom:20}}  
                    className='myFormItem'
                    name="user_type" 
                    rules={[{ required: true, message: 'يرجى اختيار نوع الحساب" ' }]}
                    label="نوع الحساب"
                    >
                        <Select size="large"  placeholder="نوع الحساب" style={{minWidth:290}}>
                            {
                                returnAccountTypesByAdminType()?.map(({value,title},index) => {
                                    return(<Option value={value} key={value} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>

                    
                    

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="fname" 
                        label=" الاسم الثلاثي"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة الاسم الثلاثي',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="الاسم الثلاثي"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="username" 
                        label="اسم المستخدم"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة اسم المستخدم',
                            }
                          ]}
                        >
                             <Input size="large" placeholder="اسم المستخدم"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item>

                    {/* <Form.Item  
                        style={{minWidth:250, marginBottom:20}}  
                        name="password" 
                        label="كلمة المرور"
                        rules={[
                            {
                              required: true,
                              message: 'يرجى كتابة كلمة المرور',
                            }
                          ]}
                        >
                             <Input.Password size="large" placeholder="كلمة المرور"  style={{minWidth:250, marginBottom:20}}  />
                    </Form.Item> */}

                    <Form.Item    
                    style={{minWidth:250, marginBottom:20}}  
                    className='myFormItem'
                    name="depart" 
                    rules={[{ required: true, message: 'يرجى اختيار القسم " ' }]}
                    label=" القسم"
                    >
                        <Select size="large"  placeholder="القسم" style={{minWidth:290}}>
                            {
                                departs?.map(({id,title},index) => {
                                    return(<Option value={id} key={id} >{title}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>
                    
                    <Button  style={{backgroundColor:Colors.primary, borderWidth:0}}  type="primary"  icon={<SendOutlined />} onClick={()=>{editAdminForm.submit()}} loading={false} >
                          ارسال الطلب
                    </Button>
                    
                </Form>

            </Drawer>
        
            <GlobalHeader title={pageTitle}/>
            <Layout>
            
            <GlobalSider currentPage={'admins'} currentSub={'sub1'} />
            <Layout
                style={{
                padding: '0 24px 24px',
                }}
            >
                <Breadcrumb
                style={{
                    margin: '16px 0',
                }}
                >
                <Breadcrumb.Item onClick={()=>navigate('/mnghome')}  style={{cursor: 'pointer'}} >الرئيسية</Breadcrumb.Item>
                <Breadcrumb.Item>{pageTitle}</Breadcrumb.Item>
                
                
                </Breadcrumb>
                <Content
                className="site-layout-background"
                style={{
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                }}
                >
                <Row  style={{padding:10}} >

                <Col md={24} >
                    {
                        ['main','university','college']?.includes(getLocal(appIdentifier)?.user?.user_type )&&
                        <Button onClick={()=> setAddAdminVisible(true) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<PlusOutlined />} size={20}>
                            اضافة  مدير
                        </Button>
                    }
                    
                   </Col>

                    <Col md={24} style={{marginTop:24}}>

                    <Table 
                        dataSource={Admins?.data}
                        pagination={{ position: ['bottomCenter'],total:totalCount}}
                        onChange={handleTableChange}
                        loading={addLoading}
                        scroll={{ x: '100%'}}
                    >

                    

                        <Column title="اسم المستخدم"  width="200px" key="title" fixed="left"
                            render={(text, record) => (
                                <Space>
                                    {`${record?.username}`}
                                </Space>
                                
                            )}
                        />

                        <Column title=" الاسم الثلاثي"  width="200px" key="fname" 
                            render={(text, record) => (
                                <Space>
                                    {`${record?.fname}`}
                                </Space>
                                
                            )}
                        />

                        

                        <Column title="البريد الالكتروني"  width="200px" key="email" 
                            render={(text, record) => (
                                <Space>
                                    {`${record?.email}`}
                                </Space>
                                
                            )}
                        />

                        <Column title="نوع المستخدم"  width="200px" key="user_type" 
                            render={(text, record) => (
                                <Space>
                                    <Tag color='geekblue' > {`${ returnUserTypeTitle(record?.user_type)}`} </Tag>
                                   
                                </Space>
                                
                            )}
                        />

                        <Column title="الجهة "  width="200px" key="org" 
                            render={(text, record) => (
                                record?.user_type == 'university'?
                                <Space>
                                {`${record?.university?.title}`}
                                </Space>
                                :
                                <Space>
                                    {`${record?.college?.title}`}{record?.depart&&`-  ${record?.depart?.title}`}
                                </Space>
                               
                                
                            )}
                        />

                        

                        {/* <Column  width={150} title="مفعل"  key="active" 
                            render={(text, record) => (
                                <Space>
                                    {record?.attributes?.active === true ? <Tag color={'green'}  >مفعل </Tag> : <Tag  color={'red'} >غير مفعل</Tag> }
                                </Space>
                            
                            )}
                             
                        />  */}

                         <Column title="العمليات"  width="200px" key="status" fixed="right"
                            render={(text, record) => (
                                <Space>
                                <Button onClick={()=> prepareEdit(record) } style={{backgroundColor:Colors.primary, borderWidth:0}} type="primary" shape="round" icon={<EditOutlined />} size={20}>
                                    تعديل
                                </Button>

                                <Button onClick={()=> showDeleteConfirm(record?.title, record?.id) } style={{backgroundColor:Colors.red, borderWidth:0}} type="primary" shape="round" icon={<DeleteOutlined />} size={20}>
                                     حذف
                                </Button>
                                </Space>
                                
                            )}
                        />
                
                    </Table>

                    </Col>
                   
                </Row>
                </Content>
            </Layout>
            </Layout>
        </Layout>
    )
}

export default MngAdmins




